var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFTwitterColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9986 10.0004C19.9986 15.051 16.2549 19.2264 11.3915 19.904C10.9368 19.9671 10.4716 20 9.9993 20C9.45417 20 8.91886 19.9566 8.39756 19.8725C3.63649 19.1059 0 14.9774 0 10.0004C0 4.47746 4.4773 0 10 0C15.5227 0 20 4.47746 20 10.0004H19.9986Z",
    fill: "#1C1C1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05534 4.41406L8.66717 10.5802L4.02661 15.5937H5.07132L9.13452 11.2045L12.4172 15.5937H15.9717L11.1006 9.08071L15.4203 4.41406H14.3755L10.634 8.45638L7.61055 4.41406H4.05603H4.05534ZM5.59121 5.18343H7.22378L14.4344 14.8243H12.8018L5.59121 5.18343Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFTwitterColored);
export default __webpack_public_path__ + "static/media/f-twitter-colored.f971bced29fef4bc18308d39c4127ecf.svg";
export { ForwardRef as ReactComponent };